<template>
  <div class="chapterOne">
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第2章 AI问题求解（6 搜索和游戏）</div>
      <div style="marginTop:30px;fontSize:12px;color:rgb(153,153,153);">2020-3-14 20:12:32</div>
      <div class="text fontBig" style="marginTop:70px;">搜索算法不一定是一种很酷的AI方法，但它们可以被用来解决我们大多数人都承认需要智能的任务，比如导航或下棋。</div>
      <div class="text fontBig">在第2章，我们将介绍以下几个部分。</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpOne">一、<span style="color:#0090ff;textDecoration:underline;">搜索和问题求解</span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpTow">二、<span style="color:#0090ff;textDecoration:underline;">用AI解决问题</span>（---）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpThree">三、<span style="color:#0090ff;textDecoration:underline;">搜索和游戏</span>（0/1）</div>
      <div  id="productId"><div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第3节 搜索和游戏</div></div>
      <div class="text fontBig">在本节中，我们将研究经典的AI问题：游戏。为了清晰起见，我们将重点介绍最简单的场景，即两人对战游戏，例如井字游戏和国际象棋。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">一、井字游戏对策</div>
      <div class="text fontBig">这里，我们通过AI方法，采用游戏树的策略，来分析如何在井字游戏（也称三子棋、圈叉游戏）对局中获胜。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">1. 游戏情境</div>
      <div class="text fontBig">马克辛和米妮是真正的游戏迷。他们很喜欢游戏，尤其是两人游戏，如井字游戏或国际象棋之类的完备信息游戏。</div>
      <div class="text fontBig">一天，马克辛（这里，我们简称Max）和米妮（简称Min）又在一起玩井字游戏。她们你来我往走了两个回合，看起来Max的玩法似乎有些问题。</div>
      <div class="text fontBig">现在，轮到Min走了，她在棋板上画了一个圈，局面看起来如图1所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-01.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图1 Min与Max在玩井字棋</div>
      <div class="text fontBig">Max看着棋板，正在考虑下一步的行动，轮到她画X了，这时她突然绝望地把脸埋入双手，看上去就像1997年与《深蓝》对战的加里·卡斯帕罗夫。</div>
      <div class="text fontBig">是的，Min就差一点在第一排形成三个圈，但是看上去，Max还是可以轻松地阻止这个计划的。那么，为什么Max会如此悲观呢？</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">2. 游戏树</div>
      <div class="text fontBig">为了使用AI解决游戏问题，我们将介绍游戏树（也叫博彩树）的概念。游戏的不同状态由游戏树中的节点表示，与上述下棋中的规划问题非常相似。</div>
      <div class="text fontBig">在游戏树中，节点的排列级别对应于游戏中每个玩家的回合，因此树的“根”节点（通常显示在图的顶部）就是游戏中的开始位置。在井字游戏中，就是没有画出X或O的空网格。</div>
      <div class="text fontBig">在根下的第二层上，有可能是第一个玩家的动作（可能是画X或O）导致的状态。我们称这些状态为根节点的“子代”或子节点。而每一个子节点又可以由对方玩家的动作导致新一层的状态。这样，逐级继续进行，直到达到游戏结束的状态。</div>
      <div class="text fontBig">显然，在井字游戏中，最后的结果，要么是其中一个玩家三个X或O排成一队获胜，要么是棋盘被填满，比赛以平局告终。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">（1）最小和最大值</div>
      <div class="text fontBig">为了能够创建尝试赢得比赛的AI游戏，我们给每个可能的最终结果赋值一个数值。如果三个X连成一队，就是Max赢了，我们赋值+1；同样，对于Min赢了的情形，我们就赋值-1；而对于棋盘已满且两个玩家均未获胜的情形，我们使用中性值0。只要这些值是按此顺序排列的，什么值并不重要，那么Max总是尝试获得最大值，而Min则会努力尝试以使其最小化。。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">（2）样本游戏树</div>
      <div class="text fontBig">考虑下面的游戏树，该树不是在游戏的根部而是在游戏的中间开始的（否则，树太大了，不便显示）。我们用1，2，...，14为节点编号。</div>
      <div class="text fontBig">该树由交替展开的层组成，在该层的任一子节点上，都可以在棋板上的任意空位中分别轮到Min画O和Max画X。左侧显示接下来要动作的玩家简称，如图2所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-02.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图2 样本游戏树</div>
      <div class="text fontBig">游戏在根节点所示的棋盘位置继续进行，在顶部以（1）编号，Min依次将O画在三个空位中的任何一个上。节点（2）–（4）分别显示了三个选择所产生的棋盘状态。在下一步中，每个节点都有两个可能的选项供Max分别画X，因此树会再次分支。</div>
      <div class="text fontBig">从上述起始位置开始，游戏最终会以三个O或X成队而结束：在节点（7）和（9）中，获胜者是画X的Max，在节点（11）–（14）中，获胜者是画O的玩家Min。</div>
      <div class="text fontBig">注：由于玩家的回合是交替的，因此可以将每一层标记为Min或Max，以表示轮到谁进行下棋动作了。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">（3）具有战略意义</div>
      <div class="text fontBig">考虑从底部开始的第二层上的节点（5）–（10）。在节点（7）和（9）中，游戏结束，Max连续三个X获胜。这些位置的值为+1。在剩下的节点（5）、（6）、（8）和（10）中，游戏实际上也结束了，因为Min只需将她的O画在剩下的唯一单元中即可获胜。换句话说，我们知道游戏将如何在第二层的每个节点处结束。因此，我们可以确定节点（5）、（6）、（8）和（10）的值也为–1，如图3所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-03.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图3 第二层某个节点的赋值</div>
      <div class="text fontBig">有趣的部分来了。让我们考虑节点的值向根部上推一层：节点（2）–（4）。由于我们观察到（2）的子节点（5）和（6）都导致了Min的胜利，因此我们可以毫不犹豫地将值-1赋值到节点（2）。但是，对于节点（3），左边的子节点（7）将导致Max的胜利，+1，而右边的子节点（8）将导致Min的胜利，-1。节点（3）的值是多少？考虑一下这个问题，记住轮到谁在节点（3）做出选择。</div>
      <div class="text fontBig">节点（4）也是这样：因为Max可以选择将X画在哪里，所以她总是可以确保胜利，我们将值+1也赋值到节点（4）。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-04.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图4 反推第一层节点的赋值</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">（4）决定谁赢</div>
      <div class="text fontBig">本节中最重要的一课是反复应用上述推理，以便从任何棋盘位置提前确定游戏结果。</div>
      <div class="text fontBig">到目前为止，我们已经确定节点（2）的值为–1，这意味着如果我们最终处于这样的棋盘位置，Min可以确保获胜，而节点（3）和（4）的情况相反：他们的值是+1，这意味着如果Max明智地进行自己的操作，Max一定会赢。</div>
      <div class="text fontBig">最后，我们可以推断出，由于Min是一位经验丰富的玩家，因此她可以得出相同的结论，即她只有一个真正的选择：在棋盘的中间位置画O。</div>
      <div class="text fontBig">在下面的图中，我们包括了每个节点的值以及从根节点轮到Min开始的最佳游戏路径。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-05.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图5 游戏最佳路径</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">结论：根节点的值=谁获胜</div>
      <div class="text fontBig">根节点的值，即游戏的值，告诉我们谁获胜（以及结果是多少，如果结果不只是简单的输赢）：如果游戏的值为+1，则Max获胜，如果值是–1，则为Min赢；如果值是0，则游戏将以平局结束。在其他游戏中，该值也可以采用其他值（例如，扑克游戏中往往用所获得的筹码的货币值论输赢）。</div>
      <div class="text fontBig">所有这些都是基于这样一个假设，即两个玩家都选择对自己最有利的事物，而对一个人最有利的事物则对另一个人最不利，这就是所谓的“零和游戏”。</div>
      <div class="text fontBig" style="color:#0090ff;">【注意】</div>
      <div class="text fontBig" style="color:#0090ff;"><b>寻找最佳操作</b></div>
      <div class="text fontBig" style="color:#0090ff;">确定了游戏树中所有节点的值之后，就可以得出最佳操作：在任何一个Min节点（轮到Min的位置）上，最优选择由其值最小的子节点给出，反之，在任何Max节点（轮到Max的位置），最佳选择由其值最大的子节点给出。有时候，会有很多同样不错的选择，而且无论选择哪一个，结果都是一样的。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">3. Minimax算法</div>
      <div class="text fontBig">我们可以利用游戏值的上述概念来获得一种称为Minimax算法的算法。从理论上讲，它可以确保在任何确定的两人零和游戏中实现最佳游戏体验。给定一个游戏状态，该算法仅计算给定状态的子代的值，如果是Max操作，则选择具有最大值的子集；如果是Min操作，则选择具有最小值的子集。</div>
      <div class="text fontBig">可以使用几行代码来实现该算法，有兴趣的话，您可以用Python或某种语言去试一试。不过，我们已经对掌握了AI算法的主要思想感到很满意了。有关Minimax算法，您可以上网搜索再了解一下。</div>
      <div class="text fontBig">如上所述，Minimax算法可用于在任何确定性的两人零和游戏中实现最佳游戏玩法。此类游戏包括井字游戏、四子棋、国际象棋、围棋、中国象棋等，如图6所示。剪刀石头布不在此类游戏中，因为它涉及对另一位玩家隐藏的信息（不属于完备信息）。不确定性的大富翁或西洋双陆棋也不是。就这个话题而言，是不是所有的人，我们现在可以回家吗？答案是理论上是，但实际上不是。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-06.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图6 Minimax算法适用场合</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">4. 大型游戏树问题</div>
      <div class="text fontBig">在许多游戏中，游戏树太大了，无法完全遍历。例如，在国际象棋中，平均分支因子，即每个节点的平均子代数（可用动作）约为35。这意味着要探索所有可能的情况（最多仅向前两个动作，即考虑两步），我们需要访问约35 x 35 = 1225个节点。若考虑三步需要访问42875个节点；四步1500625；十步2758547353515625（大约2.7万亿）节点。在围棋中，平均分支因子估计约为250，意味着围棋就不去追求Minimax算法了。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">（1）更多技巧：管理大型游戏树</div>
      <div class="text fontBig">需要更多技巧来管理庞大的游戏树。其中许多是1997年IBM深蓝计算机击败国际象棋世界冠军加里·卡斯帕罗夫的关键因素。</div>
      <div class="text fontBig">如果我们只能研究游戏树的一小部分，则需要一种方法在到达最终节点（获胜者已知的节点）前来停止Minimax算法。这是通过使用所谓的启发式评估函数来实现的，该函数将棋盘位置作为输入，包括有关下一个玩家动作的信息，并返回一个分数，该分数应该是对从给定棋盘继续进行的游戏可能结果的估计。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">（2）良好的启发式</div>
      <div class="text fontBig">例如，对国际象棋的良好启发式方法通常会计算按类型加权的材料（件）的数量：通常认为女王的价值是车的两倍，骑士或主教价值的三倍，而骑士或主教的价值是兵的三倍。国王当然比所有其他东西加起来更有价值，因为失去它等于失去了比赛。此外，在棋盘中部附近占据战略上重要的位置被认为是一种优势，并且启发式方法为此类位置分配了更高的价值。</div>
      <div class="text fontBig">上面介绍的minimax算法需要进行最小的更改才能获得深度受限的版本，在该深度受限的版本中，将在给定的深度限制下在所有节点上返回启发式：深度只是指在应用启发式评估函数之前游戏树展开的步骤数。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">【知识巩固】</div>
      <div class="text fontBig"><b>练习7：Max为什么这么悲观？</b>（Ref/-1）</div>
      <div class="text fontBig">让我们回到本节开始部分所述的井字游戏。为了缩小可能要考虑的最终游戏的空间，我们可以观察到Max必须清楚地在顶行中间画一个X以避免即将来临的失败，如图7所示。</div>
      <img style="width:100px;marginLeft:280px" src="../assets/06-07.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图7 Max只能在顶行中间画一个X</div>
      <div class="text fontBig">现在该轮到Min画O了。使用Minimax算法，评估游戏状态以及上图位置为根的游戏树中其他状态的值。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">您的任务：</div>
      <div class="text fontBig">从图7所示棋盘位置开始查看游戏树，得到的样本游戏树如图8所示。用铅笔和纸填写游戏结束的底层节点的值。注意，有些游戏以平局结束，意味着节点的值为0而不是–1或+1。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/06-08.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图8 Max画X后的样本树</div>
      <div class="text fontBig" style="marginLeft:200px;">选择您的答案<input style="marginLeft:15px;" type="radio" v-model="choosesix" value="1" :disabled="isDisabledOne"><label>1</label><input style="marginLeft:15px;" type="radio" v-model="choosesix" value="-1" :disabled="isDisabledOne"><label>-1</label><input style="marginLeft:15px;" type="radio" v-model="choosesix" value="0" :disabled="isDisabledOne"><label>0</label></div>
      <button class="sentBtn" style="marginLeft:290px" @click="sentBtnOne">提交</button>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">二、普通搜索的局限性</div>
      <div class="text fontBig">看起来我们有一种方法可以解决此问题，方法是指定状态和状态之间的转换，并找到从当前状态到目标状态的路径。当我们想在现实世界中应用AI时，事情变得更加复杂。基本上，即使是在相当复杂的现实世界中，状态的数量也无法控制，而且我们无法通过详尽的搜索（“蛮力”）或使用巧妙的启发式方法来找到解决方案。</div>
      <div class="text fontBig">而且，当我们选择一个动作时，将我们从一种状态转移到另一种状态的转换是不确定的。这意味着我们选择做的任何事情都不会总是完全确定结果，因为有些因素是我们无法控制的，而我们往往不知道这些因素。</div>
      <div class="text fontBig">我们上面讨论的算法可以适应某些随机性，例如，从混洗的牌组或掷骰子中选择牌的随机性。这意味着我们将需要引入不确定性和概率的概念。只有这样，我们才能开始采用现实世界的AI，而不是简单的难题和游戏。这是第3章的主题。</div>
      <div class="text fontBig">完成第1章后，您应该能够：</div>
      <ul>
        <li class="text fontBig">将现实问题表达为搜索问题</li>
        <li class="text fontBig">为简单的游戏（例如井字游戏）制定游戏树</li>
        <li class="text fontBig" style="marginBottom:25px;">使用minimax算法在有限大小的游戏树中找到最佳路径</li>
      </ul>
      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      choosesix:'',
      isDisabledOne:false,
    }
  },
  methods:{
    sentBtnOne(){
      this.isDisabledOne = true;
    },
    jumpOne(){
      this.$router.push('/chapterFour');
    },
    jumpTow(){
      this.$router.push('/chapterFive');
    },
    jumpThree(){
       const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    goBlank(){
      this.$router.push('/chapterFive');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/chapterSeven');
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
.text{
    text-indent:2em;
}
.fontBig{
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 30px;
    
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.anwser{
  width: 200px;
  height: 200px;
  border: 1px dashed black;
  margin-left: 230px;
  overflow:auto;
  font-size: 14px;
  outline: none;
  margin-top: 10px;
  padding: 10px;
}
.anwserInput{
  border: none;
  outline: none;
  border-bottom: 1px solid;
  font-size:16px;
}
.backBtn button{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapterSix.vue